<!-- bust cache -->

<template>
  <a
    :href="registrationUrl(forEvent)"
    @click.prevent="redirectToRegistration(forEvent)">{{ label }}</a>
</template>

<script setup>
import {registrationUrl, redirectToRegistration} from "@/composables/useRedirectToRegistration";
defineProps({
  label: {type: String, default: "Register Now"},
  forEvent: {type: String, default: undefined}
});
</script>

<style scoped>
a {
  white-space: nowrap;
  font-weight: bold;
  color: white;
  background-color: var(--brand-color);
  /* in em, the wide view's proportions at every width (Seán, 2026-10-22): its 0.6rem 2.3rem and
     17px at the wide banner's 27.68px; in rem, a phone's pill was mostly padding */
  padding: 0.35em 1.33em;
  border-radius: 0.61em;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}
:is(a:hover, a:focus) {
  background-color: var(--brand-hover-color);
  color: white;
  outline: none;
  text-decoration: none; /* global.css underlines a:hover; a button needs only the colour change */
}
a:active {
  background-color: var(--brand-hover-color);
}
</style>
